import { BaseApiRequest } from '@api/BaseApi';

export const getRigInfo = () => {
  return BaseApiRequest(null, `/RigInfo`, 'gpr', 'GET');
};

export const getUserBaselines = (token, userId) => {
  return BaseApiRequest(null, `/Baseline/GetByUserId`, 'gpr', 'POST', { userId });
};
